import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    IAgentProfileForBuyerClient,
} from 'interfaceAdapter/gatewaySchemas/IAgentProfileForBuyerClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class AgentProfileForBuyerClient implements IAgentProfileForBuyerClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, agent_id } = input;
        const PATH = `${API_LOCATION_URL}/agent/profile/for_buyer/${agent_id}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        if (token) {
            headers['X-HTTP-AUTH-TOKEN-B'] = token;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
